import { getOnpremHostname } from 'omni-package-react-core';
import { AppConfig } from '~/interfaces/AppConfig';

export default class Configuration {
  private static config: AppConfig = {
    homePath: '/eemwpnp1/public/gologin/',
    mockingEnabled: process.env.REACT_APP_MOCK_API === 'true',
    publicUrl: process.env.PUBLIC_URL,
    businessEntityCode: process.env.REACT_APP_BUSINESS_ENTITY_CODE,
    forgetPasswordPath: process.env.REACT_APP_FORGET_PASSWORD_PATH,
    forgetUserNamePath: process.env.REACT_APP_FORGET_USERNAME_PATH,
    registrationPath: process.env.REACT_APP_REGISTRATION_PATH,
    domainName: process.env.REACT_APP_DOMAIN_NAME,
    onPremHostName: getOnpremHostname(),
    idpTenantUrl: process.env.REACT_APP_IDP_TENANT_URL,
  };

  public static Current(): AppConfig { return Configuration.config; }
}
